// extracted by mini-css-extract-plugin
module.exports = {"mathTest":"MathTest_mathTest__3Z4kd","questionContainer":"MathTest_questionContainer__EcJpC","buttonContainer":"MathTest_buttonContainer__1plfi"};